
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
	name: 'BusinessTextBlockSection'
})
export default class BusinessTextBlockSection extends Vue {
	@Prop({
		type: String,
		required: false,
		default: 'left',
		validator: (value: string) => ['left', 'right'].includes(value)
	})
	readonly orientation!: string;

	@Prop({
		type: Object,
		required: true
	})
	readonly imageData!: {
		image: string;
		imageMobile?: string;
		alt: string;
		width: number;
		height: number;
	};

	@Prop({
		type: Boolean,
		default: false
	})
	readonly centerMobileImg!: boolean;

	@Prop({
		type: Boolean,
		default: false
	})
	readonly fullwidthMobileImg!: boolean;

	@Prop({
		type: Boolean,
		default: false
	})
	readonly ssr!: boolean;

	@Prop({
		type: Boolean,
		default: false
	})
	readonly hideBox!: boolean;

	@Prop({
		type: String,
		required: false,
		default: 'center',
		validator: (value: string) => ['none', 'top', 'bottom', 'center'].includes(value)
	})
	readonly imageAlignment!: string;

	get verticalAlignment(): string {
		switch (this.imageAlignment) {
			case 'none':
				return 'items-start';
			case 'top':
				return 'pb-8 items-start';
			case 'bottom':
				return 'pt-8 items-end';
			case 'center':
			default:
				return 'py-8 items-center';
		}
	}
}
